import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Vuex from 'vuex'
import router from './router'
import store from './store';
import Notifications from 'vue-notification'

Vue.config.productionTip = false

Vue.use(Notifications)

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
  data() {
    return {
      breadcrumbs: [],
    }
  }
}).$mount('#app')

Vue.use(Vuex);
